import { isNumber } from '@utils/guards';

export default function sortByPosition<T extends { position: number | null }>(list: T[]): T[] {
  return [...list].sort((a, b) => (isNumber(a.position) && isNumber(b.position) ? a.position - b.position : -1));
}
